module.exports = __webpack_public_path__ + "static/media/resources.89d8c118.png";